module.exports = __webpack_public_path__ + "static/media/background-1.9bc399f7.jpg";